export default "__VITE_ASSET__FtP3z4L8__"